import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, Phone, X } from "lucide-react";
import { WHATSAPP_DISPLAY } from "../lib/api";

const links = [
  { to: "/", label: "Home" },
  { to: "/products", label: "Products" },
  { to: "/about", label: "About" },
  { to: "/dealer-enquiry", label: "Dealers" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="rsn-navbar sticky top-0 z-50" data-testid="navbar">
      <div className="bg-[#071323] text-white border-b border-white/10">
        <div className="max-w-[1480px] mx-auto px-4 sm:px-8 h-8 flex items-center justify-between gap-5 text-[10px] sm:text-[11px] font-bold uppercase tracking-[0.14em]">
          <div className="truncate text-white/70">
            Direct from Manufacturer · Proudly Made in India · Pan-India Dispatch
          </div>
          <a
            href="tel:+918928341661"
            className="hidden sm:inline-flex items-center gap-1.5 text-white/80 whitespace-nowrap"
          >
            <Phone className="w-3.5 h-3.5" /> {WHATSAPP_DISPLAY}
          </a>
        </div>
      </div>

      <div className="bg-white border-b border-[#E1E8E4]">
        <div className="max-w-[1480px] mx-auto px-4 sm:px-8 h-[74px] flex items-center justify-between gap-6">
          <Link to="/" className="flex items-center shrink-0" data-testid="navbar-logo">
            <img
              src="/images/brand/rsn-logo.webp"
              alt="RSN Gloves - Made for Hands that Build India"
              className="h-12 sm:h-14 w-auto object-contain"
            />
          </Link>

          <nav className="hidden md:flex items-center gap-7 lg:gap-10 self-stretch">
            {links.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                data-testid={`nav-${link.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `relative h-full flex items-center text-sm font-semibold ${
                    isActive
                      ? "text-[#075B3A] after:absolute after:left-0 after:right-0 after:bottom-0 after:h-[2px] after:bg-[#075B3A]"
                      : "text-[#0F172A] hover:text-[#075B3A]"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          <Link
            to="/products"
            className="hidden md:inline-flex home-nav-cta"
            data-testid="navbar-quote-cta"
          >
            Get Bulk Quote <span aria-hidden="true">→</span>
          </Link>

          <button
            type="button"
            className="md:hidden w-10 h-10 rounded-full border border-[#DDE6E1] flex items-center justify-center text-[#075B3A] bg-white"
            onClick={() => setOpen((value) => !value)}
            aria-label="Toggle menu"
            data-testid="navbar-menu-toggle"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-white border-b border-[#DFE7E2] shadow-xl">
          <nav className="px-4 py-4 flex flex-col" data-testid="mobile-menu">
            {links.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-2 py-3.5 border-b border-[#EEF2EF] text-base font-semibold ${
                    isActive ? "text-[#075B3A]" : "text-[#0F172A]"
                  }`
                }
                data-testid={`mobile-nav-${link.label.toLowerCase()}`}
              >
                {link.label}
              </NavLink>
            ))}
            <Link
              to="/products"
              onClick={() => setOpen(false)}
              className="home-nav-cta justify-center mt-4"
              data-testid="mobile-quote-cta"
            >
              Get Bulk Quote <span aria-hidden="true">→</span>
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
